{
  "zh-TW": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "免責聲明",
        "copyright": "版權",
        "thirdpartycontent": "點數",
        "sponsors": "贊助商",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
